module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Face Api Log","systemSettings":"System Settings"}}')
  delete Component.options._Ctor
}
